// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loading_loader__1Eu3_","spin":"Loading_spin__2KgBV","small":"Loading_small__lYmJt","medium":"Loading_medium__1bUCh"};